module.exports = __webpack_public_path__ + "6d669d40f0e488d86ea5d61854527619.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room2/audio1/02_1MCA Sip My Ocean.mp3
// module id = 768
// module chunks = 0